export default __webpack_public_path__ + "static/media/voyages-white.02027290.png";